/**
 * Generated by orval 🍺
 * Do not edit manually.
 * TrainLoop Platform V2 API
 * Model evaluation workbench API
 * OpenAPI spec version: 0.0.0
 */

export type EvalRunDetailResponseStatus =
  (typeof EvalRunDetailResponseStatus)[keyof typeof EvalRunDetailResponseStatus];

export const EvalRunDetailResponseStatus = {
  completed: "completed",
  failed: "failed",
} as const;
